import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--thick-right",
  "use": "icon-chevron--thick-right-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"icon-chevron--thick-right\"><path d=\"M5.374 4.879a1.02 1.02 0 0 1 1.347 0c.186.17.279.391.279.613a.827.827 0 0 1-.279.613L1.643 10.73c-.898.818-2.245-.408-1.347-1.226l5.078-4.625v1.226L.296 1.48a.814.814 0 0 1 0-1.226 1.02 1.02 0 0 1 1.347 0L6.72 4.879c.186.17.279.391.279.613a.827.827 0 0 1-.279.613L1.643 10.73.296 9.504l5.078-4.625Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol